jQuery(document).ready(function ($) {
    $(".faq-question").on("click", function () {
        var faqItem = $(this).closest(".faq-item");
        
        // Toggle answer visibility
        faqItem.find(".faq-answer").slideToggle();
  
        // Toggle the plus/minus icon
        faqItem.find(".faq-icon-plus").toggle();
        faqItem.find(".faq-icon-minus").toggle();
    });
  $('.t4s-nav__ul_custom').on('click', '.t4s-type__mega .arrow-menu-custom', function(e) {
      e.stopPropagation();
      
      const li = $(this).closest('li.t4s-type__mega');
      if (li.hasClass('is-action__hover')) {
          li.removeClass('is-action__hover');
      } else {
          $('li.t4s-type__mega').removeClass('is-action__hover');
          li.addClass('is-action__hover');
      }
  });
  
  //   const checkFiltersInterval = setInterval(function () {
  //     $('.t4s-facet-content').each(function () {
  //       const $items = $(this).find('ul.t4s-filter__values > li');
  //       if ($items.length === 1 && !$(this).hasClass('filter-hidden')) {
  //         $(this).closest('.t4s-col-item').addClass('filter-hidden').hide(); 
  //       }
  //     });
    
  //     if ($('.t4s-facet-content').length > 0) {
  //       clearInterval(checkFiltersInterval);
  //     }
  //   }, 200);

  // const observer = new MutationObserver(function () {
  //     $('.t4s-facet-content').each(function () {
  //       const $items = $(this).find('ul.t4s-filter__values > li');
  //       if ($items.length === 1 && !$(this).hasClass('filter-hidden')) {
  //         $(this).closest('.t4s-col-item').addClass('filter-hidden').hide(); 
  //       }
  //     });
  // });
  
  // observer.observe(document.querySelector('.t4s-filter-area'), {
  //   childList: true,
  //   subtree: true
  // });



  // $(window).on('load', function() {
  //   setTimeout(function() {
  //      const interval = setInterval(function() {
  //       $('.t4s-menu-item').each(function () {
  //         var $item = $(this);
  //         var $link = $item.find('a.is-link-hover');
  //         var url = $link.attr('href');
  //         var $img = $item.find('img');
        
  //         if (url && $img.length) {
  //           var $imgParent = $img.parent();
            
  //           if ($imgParent.is('a.img-wrapper-link')) {
  //             $imgParent.attr('href', url);
  //           } 
        
  //           else if (!$imgParent.is('a')) {
  //             $img.wrap(`<a href="${url}" class="img-wrapper-link"></a>`);
  //           }
  //         }
  //       });
       
  //       if ($('.t4s-menu-item img').filter(function() {
  //         return !$(this).parent().is('a');
  //       }).length === 0) {
  //         clearInterval(interval);
  //       }
  //     }, 500);
  //   }, 1000); 
  // });

   $('.t4s-footer-link').on('click', function(e) {
      if ($(this).attr('href') === '/pages/contact' || $(this).attr('href') === '/en/pages/contact') {
        if ($('body').hasClass('template-product')) {
          e.preventDefault();
          var reference = $('.variatin-active-custom .data-reference').text().trim();
          let lang  = '';
          if($('html').attr('lang') === 'en'){
            lang = '/en'
          }
          window.location.href = lang + '/pages/contact/?reference=' + encodeURIComponent(reference);
        }
      }
    });
  
   $(window).on('load', function() {
      function getQueryParam(param) {
        return new URLSearchParams(window.location.search).get(param);
      }
      
      const interval = setInterval(() => {
        const formEmbed = document.querySelector('form-embed');
        if (!formEmbed) return;
      
        const shadowRoot = formEmbed.shadowRoot;
        if (!shadowRoot) return;
      
        const input = shadowRoot.querySelector('#custom\\#rfrence');
        const label = shadowRoot.querySelector('#label-custom\\#rfrence');
        if (!input) return;
        
        const reference = getQueryParam('reference');
        
        if(reference){
            input.value = reference; 
            label.style.transform = 'translateY(calc(1em * -0.5)) scale(0.85)';
            if($('html').attr('lang') === 'en'){
              label.textContent = 'Reference';
            }
            setTimeout(function() {
              if (input.value !== '') {
                clearInterval(interval);
                console.log('⏹️ Interval cleared, input is filled.');
              }
            }, 1000); 
        }else{
            input.style.display = 'none';
            label.style.display = 'none';
        }
       
      }, 500);
  });

   $('img')
      .on('contextmenu', function (e) { 
        e.preventDefault();
      })
      .on('dragstart', function (e) {
        e.preventDefault();
      });

    $('[style*="background-image"]')
      .on('contextmenu dragstart', function (e) {
        e.preventDefault();
      });

   // $(window).on('load', function () {
   //    const urlMap = {
   //      "/collections/piece-unique-de-juliette": "/pages/haute-joaillerie/?scroll=piece-unique-de-juliette",
   //      "/collections/madeleine-haute-joaillerie": "/pages/haute-joaillerie/?scroll=madeleine-haute-joaillerie",
   //      "/collections/collection-couleurs": "/pages/haute-joaillerie/?scroll=collection-couleurs",
   //      "/collections/sur-mesure": "/pages/haute-joaillerie/?scroll=sur-mesure"
   //    };
    
   //    const interval = setInterval(function () {
   //      let updated = false;
   //      $('.t4s-sub-menu a[href]').each(function () {
   //        const $this = $(this);
   //        const href = $this.attr('href');
   //        if (urlMap[href]) {
   //          $this.attr('href', urlMap[href]);
   //          updated = true;
   //        }
   //      });
   //      if (updated) clearInterval(interval);
   //    }, 500);
    
   //    const params = new URLSearchParams(window.location.search);
   //    const scrollTarget = params.get('scroll');
    
   //    if (scrollTarget) {
   //      setTimeout(function () {
   //        const $target = $('.' + scrollTarget);
   //        if ($target.length) {
   //          const windowWidth = $(window).width();
   //          const offset = windowWidth < 575 ? 220 : 0;
   //          $('html, body').animate({
   //            scrollTop: $target.offset().top - offset
   //          }, 2500);
   //        } else {
   //          console.warn('Scroll target not found:', scrollTarget);
   //        }
   //      }, 1000);
   //    }
   //  });
  

  $(window).on('load', function () {
    const urlMap = {
      "/collections/piece-unique-de-juliette": "piece-unique-de-juliette",
      "/collections/madeleine-haute-joaillerie": "madeleine-haute-joaillerie",
      "/collections/collection-couleurs": "collection-couleurs",
      "/collections/sur-mesure": "sur-mesure"
    };
    

    const currentPath = window.location.pathname;

    if (urlMap[currentPath]) {
      const newUrl = urlMap[currentPath];
      const targetUrl = "/pages/haute-joaillerie/?scroll=" + encodeURIComponent(newUrl);
      window.location.href = targetUrl;
    }

    // Intercept click on all anchor tags
    $('.t4s-sub-menu a[href]').on('click', function (e) {
      e.preventDefault();
      const href = $(this).attr('href');
      const url = new URL(href, window.location.origin); // Make href absolute
      if (urlMap[href]) {
        const newUrl = "/pages/haute-joaillerie/?scroll=" + encodeURIComponent(urlMap[href]);
        window.location.href = newUrl;
      }else{
        window.location.href = href;
      }
    });
  
    const interval = setInterval(function () {
      $('.t4s-sub-menu a[href]').each(function () {
        const $this = $(this);
        const href = $this.attr('href');
  
        if (urlMap[href]) {
          const scrollTarget = urlMap[href];
  
          if (currentPath === '/pages/haute-joaillerie/') {
            // On the target page: bind smooth scroll on click
            $this.on('click', function (e) {
              e.preventDefault();
              const $target = $('.' + scrollTarget);
              if ($target.length) {
                const windowWidth = $(window).width();
                const offset = windowWidth < 575 ? 0 : 0;
                 if (windowWidth < 575) {
                  $('.t4s-drawer-menu__close').trigger('click');
                }
                $('html, body').animate({
                  scrollTop: $target.offset().top - offset
                }, 1000);
              }
            });
          } else {
            // On another page: redirect to the correct scroll link
            $this.attr('href', '/pages/haute-joaillerie/?scroll=' + scrollTarget);
          }
        }
      });
  
      clearInterval(interval); // Only need to run once
    }, 500);
  
    // Handle scroll on page load (when arriving with ?scroll=...)
    const params = new URLSearchParams(window.location.search);
    const scrollTarget = params.get('scroll');
  
    if (scrollTarget) {
      setTimeout(function () {
        const $target = $('.' + scrollTarget);
        if ($target.length) {
          const windowWidth = $(window).width();
          const offset = windowWidth < 575 ? 0 : 0;
          if (windowWidth < 575) {
            $('.t4s-drawer-menu__close').trigger('click');
          }
          $('html, body').animate({
            scrollTop: $target.offset().top - offset
          }, 2500);
        } else {
          console.warn('Scroll target not found:', scrollTarget);
        }
      }, 1000);
    }
  });

  if ($('html').attr('lang') === 'en') {
      const windowWidth = $(window).width();
      let pdfUrl = "https://cdn.shopify.com/s/files/1/0813/4469/2557/files/EN_Correspondance_du_diametre_695cf72f-0364-48df-b56d-16c4305ef400.pdf?v=1749692022";
      let pdfUrl1 = "https://cdn.shopify.com/s/files/1/0813/4469/2557/files/EN_Size_guide_rings.pdf?v=1753241321";

      if (windowWidth < 575) {
            pdfUrl = "https://cdn.shopify.com/s/files/1/0813/4469/2557/files/EN_Correspondance_du_diametre_mob.pdf?v=1752545811";
            pdfUrl1 = "https://cdn.shopify.com/s/files/1/0813/4469/2557/files/EN_Size_guide_rings_mobile.pdf?v=1753241321";
      }
    
      $('.pdf3-mariage > a').each(function () {
        $(this).attr('href', pdfUrl);
      });
    
      $('.pdf3-mariage-wrap').on('click', function (e) {
        e.preventDefault();
        window.location.href = pdfUrl;
      });

      $('.pdf2-mariage > a').each(function () {
        $(this).attr('href', pdfUrl1);
      });
    
      $('.pdf2-mariage-wrap').on('click', function (e) {
        e.preventDefault();
        window.location.href = pdfUrl1;
      });

      $('.custom-link-home .g8IhhWhxAJ').attr('href', "/en/products/bague-de-fiancailles-diamants-naturels-de-mine-extra-blanc-diamant-or-blanc-20?_pos=1&_sid=9dc819f58&_ss=r&variant=49887421301069");
      $('.custom-link-home a').attr('href', "/en/products/bague-de-fiancailles-diamants-naturels-de-mine-extra-blanc-diamant-or-blanc-20?_pos=1&_sid=9dc819f58&_ss=r&variant=49887421301069");
  }else{

      const windowWidth = $(window).width();
      let pdfUrl = "https://cdn.shopify.com/s/files/1/0813/4469/2557/files/FR_Correspondance_du_diametre.pdf?v=1749087294";
      let pdfUrl1 = "https://cdn.shopify.com/s/files/1/0813/4469/2557/files/FR_Guide_des_tailles_bagues.pdf?v=1753241320";
      
      if (windowWidth < 575) {
            pdfUrl = "https://cdn.shopify.com/s/files/1/0813/4469/2557/files/FR_Correspondance_du_diametre_mob.pdf?v=1752545811";
            pdfUrl1 = "https://cdn.shopify.com/s/files/1/0813/4469/2557/files/FR_Guide_des_tailles_bagues_mobile.pdf?v=1753241321";
      }
    
      $('.pdf3-mariage > a').each(function () {
        $(this).attr('href', pdfUrl);
      });
    
      $('.pdf3-mariage-wrap').on('click', function (e) {
        e.preventDefault();
        window.location.href = pdfUrl;
      });

      $('.pdf2-mariage > a').each(function () {
        $(this).attr('href', pdfUrl1);
      });
    
      $('.pdf2-mariage-wrap').on('click', function (e) {
        e.preventDefault();
        window.location.href = pdfUrl1;
      });
  }

  document.addEventListener("DOMContentLoaded", function () {
    if (window.location.pathname.includes('/pages/notre-histoire')) {
      setInterval(function () {
        document.querySelectorAll('.slider-history p').forEach(p => {
          if (!p.textContent.replace(/\u00A0/g, '').trim()) {
            p.style.display = 'none';
          }
        });
      }, 1000); // Vérifie toutes les 1s
    }
  });

  $('body').on('click', '.t4s-mb__menu .t4s-menu-item-has-children > a[href=""]', function(e){
    e.preventDefault();
    $(this).toggleClass('is--opend');
    $(this).parent().toggleClass('is--opend');
    if( $(this).closest('.t4s-menu-item').find('.t4s-sub-menu').length > 0 ){
      $(this).closest('.t4s-menu-item').find('.t4s-sub-menu').slideToggle(300);
    }
  });
});